export const getIsActionRequired = (stage) =>
  stage === 'bounced' ||
  stage === 'enrichment_failed' ||
  stage === 'send_failed';

export const getIsCompleted = (stage) =>
  stage === 'sent' || stage === 'replied';

export const getIsSkipped = (stage) =>
  stage === 'skipped' || stage === 'bypassed';

export const getIsScheduleEnabled = (stage) =>
  stage === 'enrich' ||
  stage === 'scheduled' ||
  stage === 'paused' ||
  stage === 'pending_review';
